module.exports = __webpack_public_path__ + "img/xilingxueshantuanjian.79d22865.png";